import { Table, Checkbox, Button } from "antd";

const PayoutTable = ({
  filteredData,
  loading,
  page,
  pageSize,
  onPageChange,
  selectedRowKeys,
  handleSelectAllPage,
  handleSelectOne,
  handleToggleStatus,
  setViewingStaff,
  formatMoney,
  formatHours,
}) => {
  const currentPageData = filteredData.slice((page - 1) * pageSize, page * pageSize);
  const allPageChecked =
    currentPageData.length > 0 &&
    currentPageData.every((item) => selectedRowKeys.includes(item.id));
  // -------------------------- VAR --------------------------
  const columns = [
    {
      key: "check",
      width: 34,
      align: "center",
      className: "payout-col-check",
      title: (
        <Checkbox
          checked={allPageChecked}
          onChange={(e) => handleSelectAllPage(e.target.checked)}
        />
      ),
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.id)}
          onChange={(e) => handleSelectOne(record.id, e.target.checked)}
        />
      ),
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
      width: 90,
      className: "payout-col-name",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      width: 100,
      align: "center",
    },
    {
      title: "Payrate",
      dataIndex: "payrate",
      key: "payrate",
      width: 90,
      align: "right",
      render: (v) => formatMoney(v),
    },
    {
      title: "Total Time",
      dataIndex: "totalTime",
      key: "totalTime",
      width: 90,
      align: "right",
      render: (v) => <span className="payout-blue">{formatHours(v)}</span>,
    },
    {
      title: "Regular Hrs",
      dataIndex: "regularHrs",
      key: "regularHrs",
      width: 95,
      align: "right",
      render: (v) => formatHours(v),
    },
    {
      title: "After-Hrs",
      dataIndex: "afterHrs",
      key: "afterHrs",
      width: 80,
      align: "right",
      render: (v) => formatHours(v),
    },
    {
      title: "Holiday Hrs",
      dataIndex: "holidayHrs",
      key: "holidayHrs",
      width: 95,
      align: "right",
      render: (v) => formatHours(v),
    },
    {
      title: "Bonus",
      dataIndex: "bonus",
      key: "bonus",
      width: 80,
      align: "right",
      render: (v) => formatMoney(v || 0),
    },
    {
      title: "KiwiSaver",
      dataIndex: "kiwiSaver",
      key: "kiwiSaver",
      width: 95,
      align: "right",
      render: (v) => formatMoney(v),
    },
    {
      title: "Fuel Support",
      dataIndex: "fuelSupport",
      key: "fuelSupport",
      width: 110,
      align: "right",
      render: (v) => formatMoney(v),
    },
    {
      title: "Total Payout",
      dataIndex: "totalPayout",
      key: "totalPayout",
      width: 90,
      align: "right",
      render: (v) => <span className="payout-green">{formatMoney(v)}</span>,
    },
    {
      title: "Cash",
      dataIndex: "cash",
      key: "cash",
      width: 80,
      align: "right",
      render: (v) => (v ? formatMoney(v) : ""),
    },
    {
      title: "Bank",
      dataIndex: "bank",
      key: "bank",
      width: 80,
      align: "right",
      render: (v) => (v ? formatMoney(v) : ""),
    },
    {
      title: "Rounding Hr",
      dataIndex: "roundingHr",
      key: "roundingHr",
      width: 95,
      align: "right",
      render: (v) => (v === "-" ? "-" : formatHours(v)),
    },
    {
      title: "Paid",
      key: "paid",
      width: 60,
      align: "center",
      render: (_, record) => (
        <Checkbox
          className="payout-status-checkbox"
          checked={record.completed}
          onChange={(e) => handleToggleStatus(record, e.target.checked)}
        />
      ),
    },
    {
      key: "view",
      width: 76,
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          size="small"
          className="payout-view-btn"
          onClick={() => setViewingStaff(record)}
        >
          View
        </Button>
      ),
    },
  ];

  // -------------------------- MAIN --------------------------
  return (
    <Table
      className="payout-antd-table"
      columns={columns}
      dataSource={filteredData}
      rowKey="id"
      pagination={{ current: page, pageSize, onChange: onPageChange, showSizeChanger: false }}
      scroll={{ x: 1400 }}
      bordered
      loading={loading}
      rowClassName={(_, index) =>
        index % 2 === 0 ? "payout-row-odd" : "payout-row-even"
      }
    />
  );
};

export default PayoutTable;
